import React from "react";
import "../../pages/projectMaster/projectMaster.scss";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
};
const ProjectFilterComponent = (props) => {
  const {
    handleFilterChange,
    ProjectFilter,
    setMainCustomer,
    mainCustomerDrp,
    MainCustomer,
    setMEPCustomer,
    mepCustomerDrp,
    MEPCustomer,
    distributorData,
    Distributor,
    setDistributor,
    designCustomerDrp,
    DesignCustomer,
    setDesignCustomer,
    superCustomerDrp,
    SuperCustomer,
    setSuperCustomer,
    statusdrp,
    projectstatus,
    setStatus,
    countryData,
    ClearFilter,
    setCountry,
    ApplyFilter,
    Country,
    ProjectStatus
  } = props;
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  return (
    <div
      className="modal fade drawer right-align"
      id="filterRightSideModalPopup"
      tabindex="-1"
      role="dialog"
      aria-labelledby="filterRightSideModalPopupLabel"
    >
      <div className="modal-dialog modal-sm" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <i className="fas fa-filter"></i>
            <h5 className="modal-title">Filters</h5>
            <i className="fas fa-times" data-dismiss="modal"></i>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
              {userProfile?.userType === 1 && (<div className="mt-2">
                  <label>Distributor</label>
                  <DropDownComponent
                    placeHolder={PlaceHolder.SELECT_DISTRIBUTOR}
                    pageName="project"
                    dpDownName="distributor"
                    stateData={distributorData}
                    controlName="distributordrp"
                    handleChange={(e) => {
                      handleFilterChange(e, "Distributor");
                    }}
                    value={Distributor}
                    valueId={ProjectFilter?.Distributor}
                    setState={setDistributor}
                    multiSelect={true}
                    checkLabel={true}
                  />
                </div>)}
                <div className="mt-2">
                  <label>Main Contractor</label>
                  <DropDownComponent
                    placeHolder={PlaceHolder.SELECT_MAIN_CUSTOMER}
                    pageName="project"
                    dpDownName="customer"
                    stateData={mainCustomerDrp}
                    controlName="Maincustomerdrp"
                    handleChange={(e) => {
                      handleFilterChange(e, "MainCustomer");
                    }}
                    value={MainCustomer}
                    valueId={ProjectFilter?.MainCustomer}
                    setState={setMainCustomer}
                    multiSelect={true}
                    checkLabel={true}
                  />
                </div>
                <div className="mt-2">
                  <label>MEP Contractor</label>
                  <DropDownComponent
                    placeHolder={PlaceHolder.SELECT_MEP_CUSTOMER}
                    pageName="project"
                    dpDownName="customer"
                    stateData={mepCustomerDrp}
                    controlName="MEPcustomerdrp"
                    handleChange={(e) => {
                      handleFilterChange(e, "MEPCustomer");
                    }}
                    value={MEPCustomer}
                    valueId={ProjectFilter?.MEPCustomer}
                    setState={setMEPCustomer}
                    multiSelect={true}
                    checkLabel={true}
                  />
                </div>
                <div className="mt-2">
                  <label>Design Consultant</label>
                  <DropDownComponent
                    placeHolder={PlaceHolder.SELECT_DESIGN_CONSULTANT}
                    pageName="project"
                    dpDownName="customer"
                    stateData={designCustomerDrp}
                    controlName="Designcustomerdrp"
                    handleChange={(e) => {
                      handleFilterChange(e, "DesignCustomer");
                    }}
                    value={DesignCustomer}
                    valueId={ProjectFilter?.DesignCustomer}
                    setState={setDesignCustomer}
                    multiSelect={true}
                    checkLabel={true}
                  />
                </div>
                <div className="mt-2">
                  <label>Supervision Consultant</label>
                  <DropDownComponent
                    placeHolder={PlaceHolder.SELECT_SUPER_CONSULTANT}
                    pageName="project"
                    dpDownName="customer"
                    stateData={superCustomerDrp}
                    controlName="Supercustomerdrp"
                    handleChange={(e) => {
                      handleFilterChange(e, "SuperCustomer");
                    }}
                    value={SuperCustomer}
                    valueId={ProjectFilter?.SuperCustomer}
                    setState={setSuperCustomer}
                    multiSelect={true}
                    checkLabel={true}
                  />
                </div>
                <div className="mt-2">
                  <label>Status</label>
                  <DropDownComponent
                    placeHolder={PlaceHolder.SELECT_STATUS}
                    pageName="project"
                    dpDownName="projectstatus"
                    stateData={projectstatus}
                    controlName="projectstatus"
                    handleChange={(e) => {
                      handleFilterChange(e, "ProjectStatus");
                    }}
                    value={ProjectStatus}
                    valueId={ProjectFilter?.ProjectStatus}
                    setState={setStatus}
                    multiSelect={true}
                    checkLabel={true}
                  />
                </div>
                <div className="mt-2">
                  <label>Country</label>
                  <DropDownComponent
                    placeHolder={PlaceHolder.SELECT_COUNTRY}
                    pageName="project"
                    dpDownName="country"
                    stateData={countryData}
                    controlName="countrydrp"
                    handleChange={(e) => {
                      handleFilterChange(e, "Country");
                    }}
                    value={Country}
                    valueId={ProjectFilter?.Country}
                    setState={setCountry}
                    multiSelect={true}
                    checkLabel={true}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="footer-modal">
            <div className="row">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn clear-all-btn"
                    data-dismiss="modal"
                    onClick={(e) => ClearFilter()}
                  >
                    Clear all
                  </button>
                  <button
                    type="button"
                    className="btn apply-btn"
                    data-dismiss="modal"
                    onClick={(e) => ApplyFilter()}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectFilterComponent;
